import { type AiBuilderServerSourceRegistrationRequest } from '../store/types';

import { type AiBuilderSourceRegistrationRequest } from './types';

export const createServerSourceRegistrationRequest = ({
  draftInstanceId,
  request,
  sessionId,
}: {
  draftInstanceId: string;
  request: AiBuilderServerSourceRegistrationRequest;
  sessionId: string;
}): AiBuilderSourceRegistrationRequest =>
  request.sourceType === 'file'
    ? {
        sessionId,
        draftInstanceId,
        sourceType: request.sourceType,
        file: request.file,
        fileName: request.fileName ?? request.file.name,
        ...(request.pageRanges ? { pageRanges: request.pageRanges } : {}),
      }
    : {
        sessionId,
        draftInstanceId,
        sourceType: request.sourceType,
        url: request.url,
      };
